import Icon from '@/common/components/dataDisplay/Icon';
import { FileText } from 'lucide-react';
import React, { ReactNode } from 'react';
import Btn from './Btn';
import EllipsisText from './EllipsisText';

type Props = {
  /**
   * React children, usually text.
   */
  children: ReactNode;
}

const DocumentButton: React.FunctionComponent<Props> = (props): JSX.Element => {
  const { children } = props;

  return (
    <Btn>
      <Icon icon={FileText} variant="light" />
      <EllipsisText
        widthLarge={'200px'}
        forceSingleLine={true}
      >
        {children}
      </EllipsisText>
    </Btn>
  );
};

export default DocumentButton;
